// Dynamically import config based on environment variable
const getEnvironmentConfig = () => {
  const env = process.env.REACT_APP_ENV || "development";

  console.log(`[Config] Loading configuration for environment: ${env}`);

  switch (env) {
    case "production":
      return require("./production.json");
    case "development":
    default:
      return require("./dev.json");
  }
};

const constants = getEnvironmentConfig();

// API Gateway
export const API_GATEWAY = constants.API_GATEWAY;
export const CONSUMERAPIURL = constants.CONSUMERAPIURL;
// Environment
export const ENVIRONMENT = constants.ENVIRONMENT;
// Toggles
export const ENABLE_COUNTRY_CODE = constants.ENABLE_COUNTRY_CODE;
export const EXTERNAL_IDENTITY_LOGIN = constants.EXTERNAL_IDENTITY_LOGIN;
export const TOGGLE_HUBSPOT = constants.TOGGLE_HUBSPOT;
export const ENABLE_REGISTER_PAGE_V2 = constants.ENABLE_REGISTER_PAGE_V2;
export const ENABLE_USER_ACCOUNT_STATUS = constants.ENABLE_USER_ACCOUNT_STATUS;
export const ENABLE_VIEW_PROFILE_PAGE_V2 =
  constants.ENABLE_VIEW_PROFILE_PAGE_V2;
export const ENABLE_INVITE_USER_V2 = constants.ENABLE_INVITE_USER_V2;
export const ENABLE_WEBHOOK = constants.ENABLE_WEBHOOK;
export const ENABLE_SEGMENT = constants.ENABLE_SEGMENT;
export const DISABLE_ONBOARDING_COMPONENT =
  constants.DISABLE_ONBOARDING_COMPONENT;
export const ENABLE_ORGANIZATION_CONFIGURATION =
  constants.ENABLE_ORGANIZATION_CONFIGURATION;
export const ENABLE_REPORT_ORG_QUERY_SEARCH =
  constants.ENABLE_REPORT_ORG_QUERY_SEARCH;
export const ENABLE_MAPPING_V3 = constants.ENABLE_MAPPING_V3;
// Constants
export const TERMS_OF_SERVICE = constants.TERMS_OF_SERVICE;
export const PRIVACY_POLICY = constants.PRIVACY_POLICY;
export const INTERCOM_APP_ID = constants.INTERCOM_APP_ID;
export const INTERCOM_AP_BASE = constants.INTERCOM_AP_BASE;
export const ALLOWED_DOCUMENT_TYPES = constants.ALLOWED_DOCUMENT_TYPES;
export const HUBSPOT = constants.HUBSPOT;
export const ROLE_ENUM = constants.ROLE_ENUM;
export const STRIPE_PRICE_ID_PLANS = constants.STRIPE_PRICE_ID_PLANS;
export const STRIPE_PRICE_ID_ADDONS = constants.STRIPE_PRICE_ID_ADDONS;
export const MIXPANEL = constants.MIXPANEL;
export const SEGMENT = constants.SEGMENT;
export const STRIPE = constants.STRIPE;
export const FOLDERTYPE = constants.FOLDERTYPE;
export const ONE_DRIVE_CRED = constants.ONE_DRIVE_CRED;
export const ALLOWEDMIMETYPES = constants.ALLOWEDMIMETYPES;
export const EMAILFREQUENCY = constants.EMAILFREQUENCY;
export const G_DRIVE = constants.GOOGLE_CRED;
export const AGENT_URL = constants.AGENT_URL;
export const IS_AGENT = constants.IS_AGENT;
export const MOBILE_APP_DOWNLOAD_URL = constants.MOBILE_APP_DOWNLOAD_URL;
export const FLEXCAP_URL = constants.FLEXCAP_URL;
// Third Party Libraries Integration
export const ENABLE_FRESHDESK_CHAT = constants.ENABLE_FRESHDESK_CHAT;
export const ENABLE_BANK_RECONCILIATION_V2 =
  constants.ENABLE_BANK_RECONCILIATION_V2;
